// Fixed UI wording; backend content is localized separately.
export const checkoutDict: { en: Record<string, string>; ar: Record<string, string> } = {
  "en": {
    "login.hide_password": "Hide password",
    "login.show_password": "Show password",
    "checkout.default_address_set": "Default Address Set",
    "checkout.new_orders_will_use_this_address_by_default_existing_selections_are_preserved": "New orders will use this address by default. Existing selections are preserved.",
    "checkout.please_enter_a_promo_code": "Please enter a promo code",
    "checkout.invalid_promo_code": "Invalid promo code",
    "checkout.this_promo_code_has_expired": "This promo code has expired",
    "checkout.this_promo_code_is_not_yet_active": "This promo code is not yet active",
    "checkout.this_promo_code_has_reached_its_usage_limit": "This promo code has reached its usage limit",
    "checkout.promo_code_applied": "Promo Code Applied!",
    "checkout.failed_to_validate_promo_code": "Failed to validate promo code",
    "checkout.promo_code_removed": "Promo Code Removed",
    "checkout.the_discount_has_been_removed_from_your_order": "The discount has been removed from your order.",
    "checkout.item_removed": "Item Removed",
    "checkout.the_item_has_been_removed_from_your_cart": "The item has been removed from your cart.",
    "checkout.select_address": "Select address",
    "checkout.please_add_a_shipping_address": "Please add a shipping address",
    "checkout.failed_to_create_checkout_session": "Failed to create checkout session",
    "checkout.open_payment_page": "Open Payment Page",
    "checkout.your_browser_blocked_the_payment_popup_tap_open_to_continue_to_payment": "Your browser blocked the payment popup. Tap Open to continue to payment.",
    "checkout.open_payment": "Open payment",
    "checkout.open": "Open",
    "checkout.payment_failed": "Payment Failed",
    "checkout.there_was_a_problem_initiating_payment_please_try_again": "There was a problem initiating payment. Please try again.",
    "checkout.back": "Back",
    "checkout.final_step": "Final Step",
    "checkout.complete_your_order": "Complete Your Order",
    "checkout.promotion_code": "Promotion Code",
    "checkout.remove_promo_code": "Remove promo code",
    "checkout.enter_promo_code": "Enter promo code",
    "checkout.apply": "Apply",
    "checkout.order_summary": "Order Summary",
    "checkout.select_all_items_for_checkout": "Select all items for checkout",
    "checkout.edit_item": "Edit item",
    "checkout.remove_item": "Remove Item",
    "checkout.sample": "Sample",
    "checkout.anaya_signature_box": "ANAYA Signature Box",
    "checkout.100ml_single_perfume": "100ml Single Perfume",
    "checkout.anaya_collection": "Anaya Collection",
    "checkout.sensation_formal": "Sensation (Formal)",
    "checkout.fresh_energy_outdoor": "Fresh Energy (Outdoor)",
    "checkout.casual_everyday": "Casual (Everyday)",
    "checkout.re_order": "Re-order",
    "checkout.top_notes": "Top Notes:",
    "checkout.heart": "Heart:",
    "checkout.base": "Base:",
    "checkout.code": "Code:",
    "checkout.greeting_card": "Greeting Card",
    "checkout.included": "Included",
    "checkout.custom_photo": "Custom photo",
    "checkout.custom_photo_included": "Custom photo included",
    "checkout.order_total": "Order Total",
    "checkout.discount": "Discount",
    "checkout.remove_ticket_credit": "Remove ticket credit",
    "checkout.apply_ticket_credit": "Apply ticket credit",
    "checkout.1_ticket_credit": "1 Ticket Credit",
    "checkout.ticket_available": "Ticket available",
    "checkout.subtotal": "Subtotal",
    "checkout.ship_to": "Ship to:",
    "checkout.default": "Default",
    "checkout.shipping": "Shipping",
    "checkout.free": "Free",
    "checkout.original_total": "Original Total",
    "checkout.net_total": "Net Total",
    "checkout.all_prices_include_vat": "All prices include VAT",
    "checkout.estimated_delivery": "Estimated Delivery:",
    "checkout.3_5_business_days": "3-5 business days",
    "checkout.5_7_business_days": "5-7 business days",
    "checkout.3_5_days_uae_5_7_days_international": "3-5 days (UAE) / 5-7 days (International)",
    "checkout.special_request": "Special Request",
    "checkout.any_special_instructions_max_20_words": "Any special instructions? (max 20 words)",
    "checkout.want_to_add_another_gift_to_your_order": "Want to add another gift to your order?",
    "checkout.add_more_from_anaya_collection": "Add More from Anaya Collection",
    "checkout.add_more_quiz_options": "Add More (Quiz Options)",
    "checkout.redirecting_to_payment": "Redirecting to Payment...",
    "checkout.powered_by_stripe": "Powered by Stripe",
    "checkout.your_wishlist": "Your Wishlist",
    "checkout.are_you_sure_you_want_to_remove_this_item_from_your_order": "Are you sure you want to remove this item from your order?",
    "checkout.cancel": "Cancel",
    "checkout.remove": "Remove",
    "address.first_name_is_required": "First name is required",
    "address.last_name_is_required": "Last name is required",
    "address.address_is_required": "Address is required",
    "address.city_is_required": "City is required",
    "address.country_is_required": "Country is required",
    "address.phone_number_is_required": "Phone number is required",
    "address.postal_code_is_required": "Postal code is required",
    "address.state_region_is_required": "State/region is required",
    "address.invalid_phone_number": "Invalid phone number",
    "address.address_updated": "Address Updated",
    "address.your_shipping_address_has_been_updated": "Your shipping address has been updated.",
    "address.address_saved": "Address Saved",
    "address.your_shipping_address_has_been_added": "Your shipping address has been added.",
    "address.error": "Error",
    "address.failed_to_save_address_please_try_again": "Failed to save address. Please try again.",
    "address.failed_to_delete_address": "Failed to delete address.",
    "address.address_removed": "Address Removed",
    "address.the_shipping_address_has_been_deleted": "The shipping address has been deleted.",
    "address.default_address_set": "Default Address Set",
    "address.this_address_will_be_used_for_new_orders": "This address will be used for new orders.",
    "address.address_required": "Address Required",
    "address.please_add_a_shipping_address_to_continue": "Please add a shipping address to continue.",
    "address.delivery_details": "Delivery Details",
    "address.shipping_address": "Shipping Address",
    "address.select_a_delivery_address_or_add_a_new_one": "Select a delivery address or add a new one",
    "address.add_your_delivery_address_to_continue": "Add your delivery address to continue",
    "address.default": "Default",
    "address.set_as_default": "Set as Default",
    "address.edit_address": "Edit Address",
    "address.delete_address": "Delete address",
    "address.add_new_shipping_address": "Add New Shipping Address",
    "address.new_shipping_address": "New Shipping Address",
    "address.cancel": "Cancel",
    "address.select_your_country": "Select your country",
    "address._optional": "(optional)",
    "address.saving": "Saving...",
    "address.update_address": "Update Address",
    "address.save_address": "Save Address",
    "address.back": "Back",
    "address.continue_to_checkout": "Continue to Checkout",
    "login.please_enter_a_valid_email": "Please enter a valid email",
    "login.minimum_6_characters": "Minimum 6 characters",
    "login.password_must_be_at_least_6_characters": "Password must be at least 6 characters",
    "login.invalid_email_or_password": "Invalid email or password",
    "login.welcome_back": "Welcome back!",
    "login.redirecting_to_shipping_address": "Redirecting to shipping address...",
    "login.email_already_registered_please_sign_in_instead": "Email already registered. Please sign in instead.",
    "login.account_created": "Account created!",
    "login.redirecting_to_add_your_shipping_address": "Redirecting to add your shipping address...",
    "login.reset_email_sent": "Reset email sent",
    "login.check_your_inbox_for_password_reset_instructions": "Check your inbox for password reset instructions.",
    "login.google_sign_in_failed": "Google Sign-In Failed",
    "login.error": "Error",
    "login.an_unexpected_error_occurred_please_try_again": "An unexpected error occurred. Please try again.",
    "login.password_recovery": "Password Recovery",
    "login.account_details": "Account Details",
    "login.reset_password": "Reset Password",
    "login.login_details": "Login Details",
    "login.enter_your_email_and_we_ll_send_you_instructions_to_reset_your_password": "Enter your email and we'll send you instructions to reset your password",
    "login.create_an_account_to_save_your_order_and_track_delivery": "Create an account to save your order and track delivery",
    "login.sign_in_to_access_your_saved_addresses_and_order_history": "Sign in to access your saved addresses and order history",
    "login.new_customer": "New Customer",
    "login.returning_customer": "Returning Customer",
    "login.or": "or",
    "login.continue_with_google": "Continue with Google",
    "login.password_reset_instructions_have_been_sent_to_your_email": "Password reset instructions have been sent to your email.",
    "login.back_to_sign_in": "Back to Sign In",
    "login.email": "Email",
    "login.password": "Password",
    "login.forgot_password": "Forgot password?",
    "login.mobile_phone": "Mobile Phone",
    "login._optional": "(optional)",
    "login.phone_number": "Phone number",
    "login.send_reset_link": "Send Reset Link",
    "login.create_account_continue": "Create Account & Continue",
    "login.back": "Back",
    "checkout.selection_count": "({selected} of {total} selected)",
    "checkout.order_for": "Order {number} - For {name}",
    "checkout.discount_off": "{amount} off",
    "checkout.promo_savings": "{amount} off your order.",
    "checkout.less_promo": "Less Promo Discount ({code})",
    "checkout.less_tickets": "Less Ticket Credits ({count})",
    "checkout.word_count": "{count}/20 words",
    "checkout.proceed_payment": "Proceed to Payment - {amount}",
    "address.required_field": "{field} is required",
    "login.sending_": "Sending...",
    "login.signing_in_": "Signing in...",
    "login.creating_account_": "Creating account...",
    "login.sign_in": "Sign In"
  },
  "ar": {
    "login.hide_password": "إخفاء كلمة المرور",
    "login.show_password": "إظهار كلمة المرور",
    "checkout.default_address_set": "تم تعيين العنوان الافتراضي",
    "checkout.new_orders_will_use_this_address_by_default_existing_selections_are_preserved": "ستستخدم الطلبات الجديدة هذا العنوان افتراضيًا مع الاحتفاظ بالاختيارات الحالية.",
    "checkout.please_enter_a_promo_code": "يرجى إدخال رمز ترويجي",
    "checkout.invalid_promo_code": "الرمز الترويجي غير صالح",
    "checkout.this_promo_code_has_expired": "انتهت صلاحية هذا الرمز الترويجي",
    "checkout.this_promo_code_is_not_yet_active": "هذا الرمز الترويجي غير مفعّل بعد",
    "checkout.this_promo_code_has_reached_its_usage_limit": "بلغ هذا الرمز الترويجي الحد الأقصى للاستخدام",
    "checkout.promo_code_applied": "تم تطبيق الرمز الترويجي!",
    "checkout.failed_to_validate_promo_code": "تعذّر التحقق من الرمز الترويجي",
    "checkout.promo_code_removed": "تمت إزالة الرمز الترويجي",
    "checkout.the_discount_has_been_removed_from_your_order": "تمت إزالة الخصم من طلبك.",
    "checkout.item_removed": "تمت إزالة المنتج",
    "checkout.the_item_has_been_removed_from_your_cart": "تمت إزالة المنتج من سلة التسوق.",
    "checkout.select_address": "اختر عنوانًا",
    "checkout.please_add_a_shipping_address": "يرجى إضافة عنوان للشحن",
    "checkout.failed_to_create_checkout_session": "تعذّر بدء إتمام الشراء",
    "checkout.open_payment_page": "فتح صفحة الدفع",
    "checkout.your_browser_blocked_the_payment_popup_tap_open_to_continue_to_payment": "حظر المتصفح نافذة الدفع المنبثقة. اضغط على فتح للمتابعة إلى الدفع.",
    "checkout.open_payment": "فتح صفحة الدفع",
    "checkout.open": "فتح",
    "checkout.payment_failed": "تعذّر الدفع",
    "checkout.there_was_a_problem_initiating_payment_please_try_again": "حدثت مشكلة أثناء بدء الدفع. يرجى المحاولة مجددًا.",
    "checkout.back": "رجوع",
    "checkout.final_step": "الخطوة الأخيرة",
    "checkout.complete_your_order": "أكمل طلبك",
    "checkout.promotion_code": "الرمز الترويجي",
    "checkout.remove_promo_code": "إزالة الرمز الترويجي",
    "checkout.enter_promo_code": "أدخل الرمز الترويجي",
    "checkout.apply": "تطبيق",
    "checkout.order_summary": "ملخص الطلب",
    "checkout.select_all_items_for_checkout": "تحديد جميع المنتجات لإتمام الشراء",
    "checkout.edit_item": "تعديل المنتج",
    "checkout.remove_item": "إزالة المنتج",
    "checkout.sample": "عينة",
    "checkout.anaya_signature_box": "صندوق أنايا المميز",
    "checkout.100ml_single_perfume": "عطر منفرد 100 مل",
    "checkout.anaya_collection": "مجموعة أنايا",
    "checkout.sensation_formal": "إحساس (للمناسبات الرسمية)",
    "checkout.fresh_energy_outdoor": "طاقة منعشة (للأنشطة الخارجية)",
    "checkout.casual_everyday": "عفوي (للاستخدام اليومي)",
    "checkout.re_order": "إعادة طلب",
    "checkout.top_notes": "النفحات الافتتاحية:",
    "checkout.heart": "القلب:",
    "checkout.base": "القاعدة:",
    "checkout.code": "الرمز:",
    "checkout.greeting_card": "بطاقة إهداء",
    "checkout.included": "مشمولة",
    "checkout.custom_photo": "صورة مخصصة",
    "checkout.custom_photo_included": "صورة مخصصة مشمولة",
    "checkout.order_total": "إجمالي الطلب",
    "checkout.discount": "الخصم",
    "checkout.remove_ticket_credit": "إزالة رصيد القسيمة",
    "checkout.apply_ticket_credit": "تطبيق رصيد القسيمة",
    "checkout.1_ticket_credit": "رصيد قسيمة واحدة",
    "checkout.ticket_available": "قسيمة متاحة",
    "checkout.subtotal": "المجموع الفرعي",
    "checkout.ship_to": "الشحن إلى:",
    "checkout.default": "افتراضي",
    "checkout.shipping": "الشحن",
    "checkout.free": "مجاني",
    "checkout.original_total": "الإجمالي الأصلي",
    "checkout.net_total": "الإجمالي الصافي",
    "checkout.all_prices_include_vat": "جميع الأسعار تشمل ضريبة القيمة المضافة",
    "checkout.estimated_delivery": "التوصيل المتوقع:",
    "checkout.3_5_business_days": "3–5 أيام عمل",
    "checkout.5_7_business_days": "5–7 أيام عمل",
    "checkout.3_5_days_uae_5_7_days_international": "3–5 أيام (الإمارات) / 5–7 أيام (دوليًا)",
    "checkout.special_request": "طلب خاص",
    "checkout.any_special_instructions_max_20_words": "هل لديك تعليمات خاصة؟ (20 كلمة كحد أقصى)",
    "checkout.want_to_add_another_gift_to_your_order": "هل ترغب في إضافة هدية أخرى إلى طلبك؟",
    "checkout.add_more_from_anaya_collection": "أضف المزيد من مجموعة أنايا",
    "checkout.add_more_quiz_options": "أضف المزيد (خيارات الاستبيان)",
    "checkout.redirecting_to_payment": "جارٍ الانتقال إلى الدفع...",
    "checkout.powered_by_stripe": "الدفع عبر Stripe",
    "checkout.your_wishlist": "قائمة أمنياتك",
    "checkout.are_you_sure_you_want_to_remove_this_item_from_your_order": "هل أنت متأكد من رغبتك في إزالة هذا المنتج من طلبك؟",
    "checkout.cancel": "إلغاء",
    "checkout.remove": "إزالة",
    "address.first_name_is_required": "الاسم الأول مطلوب",
    "address.last_name_is_required": "اسم العائلة مطلوب",
    "address.address_is_required": "العنوان مطلوب",
    "address.city_is_required": "المدينة مطلوبة",
    "address.country_is_required": "الدولة مطلوبة",
    "address.phone_number_is_required": "رقم الهاتف مطلوب",
    "address.postal_code_is_required": "الرمز البريدي مطلوب",
    "address.state_region_is_required": "الولاية أو المنطقة مطلوبة",
    "address.invalid_phone_number": "رقم الهاتف غير صالح",
    "address.address_updated": "تم تحديث العنوان",
    "address.your_shipping_address_has_been_updated": "تم تحديث عنوان الشحن الخاص بك.",
    "address.address_saved": "تم حفظ العنوان",
    "address.your_shipping_address_has_been_added": "تمت إضافة عنوان الشحن الخاص بك.",
    "address.error": "خطأ",
    "address.failed_to_save_address_please_try_again": "تعذّر حفظ العنوان. يرجى المحاولة مجددًا.",
    "address.failed_to_delete_address": "تعذّر حذف العنوان.",
    "address.address_removed": "تمت إزالة العنوان",
    "address.the_shipping_address_has_been_deleted": "تم حذف عنوان الشحن.",
    "address.default_address_set": "تم تعيين العنوان الافتراضي",
    "address.this_address_will_be_used_for_new_orders": "سيُستخدم هذا العنوان للطلبات الجديدة.",
    "address.address_required": "عنوان الشحن مطلوب",
    "address.please_add_a_shipping_address_to_continue": "يرجى إضافة عنوان للشحن للمتابعة.",
    "address.delivery_details": "تفاصيل التوصيل",
    "address.shipping_address": "عنوان الشحن",
    "address.select_a_delivery_address_or_add_a_new_one": "اختر عنوانًا للتوصيل أو أضف عنوانًا جديدًا",
    "address.add_your_delivery_address_to_continue": "أضف عنوان التوصيل للمتابعة",
    "address.default": "افتراضي",
    "address.set_as_default": "تعيين كافتراضي",
    "address.edit_address": "تعديل العنوان",
    "address.delete_address": "حذف العنوان",
    "address.add_new_shipping_address": "إضافة عنوان شحن جديد",
    "address.new_shipping_address": "عنوان شحن جديد",
    "address.cancel": "إلغاء",
    "address.select_your_country": "اختر دولتك",
    "address._optional": "（اختياري）",
    "address.saving": "جارٍ الحفظ...",
    "address.update_address": "تحديث العنوان",
    "address.save_address": "حفظ العنوان",
    "address.back": "رجوع",
    "address.continue_to_checkout": "المتابعة لإتمام الشراء",
    "login.please_enter_a_valid_email": "يرجى إدخال بريد إلكتروني صالح",
    "login.minimum_6_characters": "6 أحرف على الأقل",
    "login.password_must_be_at_least_6_characters": "يجب ألا تقل كلمة المرور عن 6 أحرف",
    "login.invalid_email_or_password": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    "login.welcome_back": "مرحبًا بعودتك!",
    "login.redirecting_to_shipping_address": "جارٍ الانتقال إلى عنوان الشحن...",
    "login.email_already_registered_please_sign_in_instead": "هذا البريد الإلكتروني مسجّل بالفعل. يرجى تسجيل الدخول.",
    "login.account_created": "تم إنشاء الحساب!",
    "login.redirecting_to_add_your_shipping_address": "جارٍ الانتقال لإضافة عنوان الشحن...",
    "login.reset_email_sent": "تم إرسال رسالة إعادة التعيين",
    "login.check_your_inbox_for_password_reset_instructions": "تحقق من بريدك الوارد للاطلاع على تعليمات إعادة تعيين كلمة المرور.",
    "login.google_sign_in_failed": "تعذّر تسجيل الدخول باستخدام Google",
    "login.error": "خطأ",
    "login.an_unexpected_error_occurred_please_try_again": "حدث خطأ غير متوقع. يرجى المحاولة مجددًا.",
    "login.password_recovery": "استعادة كلمة المرور",
    "login.account_details": "تفاصيل الحساب",
    "login.reset_password": "إعادة تعيين كلمة المرور",
    "login.login_details": "بيانات تسجيل الدخول",
    "login.enter_your_email_and_we_ll_send_you_instructions_to_reset_your_password": "أدخل بريدك الإلكتروني وسنرسل إليك تعليمات إعادة تعيين كلمة المرور",
    "login.create_an_account_to_save_your_order_and_track_delivery": "أنشئ حسابًا لحفظ طلبك وتتبع التوصيل",
    "login.sign_in_to_access_your_saved_addresses_and_order_history": "سجّل الدخول للوصول إلى عناوينك المحفوظة وسجل طلباتك",
    "login.new_customer": "عميل جديد",
    "login.returning_customer": "عميل حالي",
    "login.or": "أو",
    "login.continue_with_google": "المتابعة باستخدام Google",
    "login.password_reset_instructions_have_been_sent_to_your_email": "تم إرسال تعليمات إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.",
    "login.back_to_sign_in": "العودة إلى تسجيل الدخول",
    "login.email": "البريد الإلكتروني",
    "login.password": "كلمة المرور",
    "login.forgot_password": "هل نسيت كلمة المرور؟",
    "login.mobile_phone": "رقم الهاتف المحمول",
    "login._optional": "（اختياري）",
    "login.phone_number": "رقم الهاتف",
    "login.send_reset_link": "إرسال رابط إعادة التعيين",
    "login.create_account_continue": "إنشاء حساب والمتابعة",
    "login.back": "رجوع",
    "checkout.selection_count": "(تم تحديد {selected} من {total})",
    "checkout.order_for": "الطلب {number} - إلى {name}",
    "checkout.discount_off": "خصم {amount}",
    "checkout.promo_savings": "خصم {amount} على طلبك.",
    "checkout.less_promo": "يُخصم الرمز الترويجي ({code})",
    "checkout.less_tickets": "يُخصم رصيد القسائم ({count})",
    "checkout.word_count": "{count}/20 كلمة",
    "checkout.proceed_payment": "المتابعة إلى الدفع - {amount}",
    "address.required_field": "{field} مطلوب",
    "login.sending_": "جارٍ الإرسال...",
    "login.signing_in_": "جارٍ تسجيل الدخول...",
    "login.creating_account_": "جارٍ إنشاء الحساب...",
    "login.sign_in": "تسجيل الدخول"
  }
};
